//
//
//
//
//
//

export default {
  props: ['icon', 'page', 'label', 'type', 'highlight'],
  methods: {
    close() {
      this.$store.commit('openLeftSidebar', false)
    }
  }
}
